import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  onClick,
  type = 'button',
  style = {},
  ...props
}) => {
  const baseStyles = {
    borderRadius: 'var(--border-radius-md, 8px)',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 'var(--font-size-base, 16px)',
    padding: 'var(--spacing-sm, 8px) var(--spacing-lg, 16px)',
    minHeight: '44px',
    transition: 'all 0.2s ease-in-out',
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    width: fullWidth ? '100%' : 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'inherit',
    ...style
  };

  const variantStyles = {
    primary: {
      backgroundColor: 'var(--color-primary, #2a4d69)',
      color: 'white',
    },
    secondary: {
      backgroundColor: 'var(--color-secondary, #4a90d9)',
      color: 'white',
    },
    success: {
      backgroundColor: 'var(--color-success, #27ae60)',
      color: 'white',
    },
    error: {
      backgroundColor: 'var(--color-error, #e74c3c)',
      color: 'white',
    },
    outlined: {
      backgroundColor: 'transparent',
      color: 'var(--color-primary, #2a4d69)',
      border: '2px solid var(--color-primary, #2a4d69)',
    },
    text: {
      backgroundColor: 'transparent',
      color: 'var(--color-primary, #2a4d69)',
      border: 'none',
    }
  };

  const disabledStyles = disabled ? {
    backgroundColor: '#ccc',
    color: '#666',
    cursor: 'not-allowed',
    opacity: 0.6
  } : {};

  const finalStyles = {
    ...baseStyles,
    ...variantStyles[variant],
    ...disabledStyles
  };

  const handleMouseEnter = (e) => {
    if (!disabled) {
      e.target.style.transform = 'translateY(-1px)';
      e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
    }
  };

  const handleMouseLeave = (e) => {
    if (!disabled) {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = 'none';
    }
  };

  const handleMouseDown = (e) => {
    if (!disabled) {
      e.target.style.transform = 'translateY(1px)';
    }
  };

  const handleMouseUp = (e) => {
    if (!disabled) {
      e.target.style.transform = 'translateY(-1px)';
    }
  };

  return (
    <button
      style={finalStyles}
      disabled={disabled}
      onClick={onClick}
      type={type}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
